import React from 'react';
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router";
import { logOut } from "../features/auth/authSlice";
import { useContext } from "react";
import { GlobalStateContext } from "../store/GlobalState";

export default function useLogOut() {

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const globalState = useContext(GlobalStateContext);
    const logoutUser = () => {
        dispatch(logOut());
        localStorage.setItem('accessToken', '');
        localStorage.setItem('refreshToken', '');
        localStorage.setItem('expires', '');

        globalState.setAccessToken('');
        globalState.setRefreshToken('');
        globalState.setExpires('');

        navigate('/');
    }
    return { logoutUser }

};